import React, { useEffect, useState, useRef, useCallback } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { SearchJob, CreateMyJobs } from "../../../Redux/Slices/JobPost";
import { useDispatch, useSelector } from "react-redux";
import { PiBagSimple } from "react-icons/pi";
import { LiaRupeeSignSolid, LiaIndustrySolid } from "react-icons/lia";
import { GoLocation } from "react-icons/go";
import { SlGraduation } from "react-icons/sl";
import { FaThLarge, FaList, FaBookmark, FaRegBookmark, FaSortAmountDown, FaSearch } from "react-icons/fa";
import { BsFilter } from "react-icons/bs";
import { BarLoader } from "react-spinners";
import { formatTimeAgo } from "../../../Helper/FromatTime";
import { formatJobLocation } from "../../../Helper/CoreHelper";
import Location from "../../Admin/Location";
import SearchImg from "../../../asset/new/images/40-02-02.png";
import {
  yearOption,
  lacOption,
  thousandOption,
} from "../../../Helper/Option";
import "./FeaturedJob.css";
import toast from "react-hot-toast";
import { FetchQualifications } from "../../../Redux/Slices/Qualification";
import SeoHead from "../../Common/SeoHead";
import {
  getListingPage,
  matchQualificationNames,
  QUALIFICATION_FALLBACK_KEYWORD,
  SOURCE_PATHS,
  LISTING_PATHS,
} from "../../../constants/seo";
import { buildItemListJsonLd } from "../../../Helper/structuredData";

const getJobSalaryValue = (job) => {
  const lac = Number(job?.ctc?.from_lac);
  const thousand = Number(job?.ctc?.from_thousand);
  const hasSalary =
    (job?.ctc?.from_lac !== null && job?.ctc?.from_lac !== undefined && job?.ctc?.from_lac !== "") ||
    (job?.ctc?.to_lac !== null && job?.ctc?.to_lac !== undefined && job?.ctc?.to_lac !== "");

  if (!hasSalary) return null;
  return (Number.isFinite(lac) ? lac : 0) * 100 + (Number.isFinite(thousand) ? thousand : 0);
};

const compareSalary = (a, b, direction = "desc") => {
  const salaryA = getJobSalaryValue(a);
  const salaryB = getJobSalaryValue(b);
  if (salaryA == null && salaryB == null) return 0;
  if (salaryA == null) return 1;
  if (salaryB == null) return -1;
  return direction === "desc" ? salaryB - salaryA : salaryA - salaryB;
};

const LEGACY_JOB_SOURCE_CATEGORIES = [
  { key: "all", label: "All Jobs", types: [] },
  {
    key: "featured",
    label: "Featured Jobs",
    types: ["Featured Jobs"],
    infoDescription: "Jobs managed by CAJobPortal on behalf of clients",
  },
  {
    key: "career",
    label: "PSU Jobs / Career Sites",
    types: ["Carrer Sites", "Career Sites", "Government Jobs", "PSU Jobs / Career sites"],
    infoDescription: "Jobs hosted on the career sites of companies",
  },
  {
    key: "third-party",
    label: "Third Party Listings",
    types: ["ThirdParty Listing", "Third Party Listing", "Third party listings", "Short-Term Assignments"],
    infoDescription: "Jobs posted directly by companies / search firms",
  },
];

const FilterDropdown = ({ name, value, options, placeholder, openFilter, setOpenFilter, onChange }) => {
  const isOpen = openFilter === name;
  const selectedLabel = options.find(o => String(o.value) === String(value))?.label || placeholder;
  return (
    <div className="filter-dropdown-wrapper">
      <button
        type="button"
        className="filter-chip-btn"
        onClick={(e) => { e.stopPropagation(); setOpenFilter(isOpen ? null : name); }}
      >
        <span className="filter-chip-value">{selectedLabel}</span>
        <span className={`filter-chip-arrow ${isOpen ? 'open' : ''}`}>▾</span>
      </button>
      {isOpen && (
        <div className="filter-dropdown-menu">
          {options.map(opt => (
            <button
              key={opt.value}
              type="button"
              className={`filter-option-item ${String(value) === String(opt.value) ? 'active' : ''}`}
              onClick={() => { onChange({ target: { name, value: opt.value } }); setOpenFilter(null); }}
            >
              {opt.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

const FeaturedJobModern = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  
  const { allJobs } = useSelector((state) => state?.Jobs);
  const { qualificationsData } = useSelector((state) => state?.Qualification);
  
  const [searchedJob, setSearchJob] = useState(allJobs);
  const [loading, setLoading] = useState(false);
  const [isTyping, setIsTyping] = useState(false);
  const [viewMode, setViewMode] = useState("grid");
  const [sortBy, setSortBy] = useState("relevance");
  const [showFilters, setShowFilters] = useState(false);
  const [showSortDropdown, setShowSortDropdown] = useState(false);
  const [openFilter, setOpenFilter] = useState(null);
  const [selectedSourceCategory, setSelectedSourceCategory] = useState("all");
  const sortDropdownRef = useRef(null);
  const isInitialMount = useRef(true);
  const [savedJobs, setSavedJobs] = useState(new Set());
  const [searchHistory, setSearchHistory] = useState(null);
  
  const [locationData, setLocationData] = useState({
    Country: "",
    State: "",
    Cities: [],
  });
  
  const [searchQuery, setSearchQuery] = useState({
    keyword: "",
    daysAgo: "",
    industry: "",
    exp_from: "",
    exp_to: "",
    ctc_from_lacs: "",
    ctc_from_thousand: "",
    ctc_to_lacs: "",
    ctc_to_thousand: "",
  });
  const locationStateCities =
    location.state?.cities || location.state?.data?.cities || [];
  const userName = localStorage.getItem("name") || "";
  const firstName = userName.trim() ? userName.trim().split(" ")[0] : "";

  const listingPage = getListingPage(location.pathname);
  const listingQualifications = matchQualificationNames(
    qualificationsData,
    listingPage.qualificationKey
  );

  const resolveInitialSourceCategory = useCallback(() => {
    if (LISTING_PATHS.includes(location.pathname) && listingPage.source) {
      return listingPage.source;
    }

    const sourceParam = new URLSearchParams(location.search).get("source");
    const sourceByQuery = {
      featured: "featured",
      career: "career",
      "third-party": "third-party",
      thirdparty: "third-party",
      all: "all",
    };

    return sourceByQuery[sourceParam] || "all";
  }, [location.pathname, location.search, listingPage.source]);

  const getSourceTypes = useCallback(
    (categoryKey = selectedSourceCategory) =>
      LEGACY_JOB_SOURCE_CATEGORIES.find((item) => item.key === categoryKey)?.types || [],
    [selectedSourceCategory]
  );

  // Close sort dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (sortDropdownRef.current && !sortDropdownRef.current.contains(e.target)) {
        setShowSortDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Close filter dropdowns on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest('.filter-dropdown-wrapper')) {
        setOpenFilter(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    dispatch(FetchQualifications());
  }, [dispatch]);

  useEffect(() => {
    const sourceParam = new URLSearchParams(location.search).get("source");
    const mappedSourcePath = SOURCE_PATHS[sourceParam];
    if (location.pathname === "/jobs" && mappedSourcePath && mappedSourcePath !== "/jobs") {
      navigate(mappedSourcePath, { replace: true });
    }
  }, [location.pathname, location.search, navigate]);

  // Fetch initial data
  useEffect(() => {
    const initialSourceCategory = resolveInitialSourceCategory();
    setSelectedSourceCategory(initialSourceCategory);

    const urlParams = new URLSearchParams(location.search);
    const keywordParam = urlParams.get("keyword") || "";
    const locationParam = urlParams.get("location");
    const cities = locationParam ? [locationParam] : [];

    if (keywordParam) {
      setSearchQuery((prev) => ({ ...prev, keyword: keywordParam }));
    }

    if (locationParam) {
      setLocationData((prev) => ({ ...prev, Cities: [locationParam] }));
    }

    if (listingQualifications[0]) {
      setSearchQuery((prev) => ({ ...prev, industry: listingQualifications[0] }));
    }

    performSearch(keywordParam, cities, initialSourceCategory, listingQualifications);
    isInitialMount.current = false;
  }, [resolveInitialSourceCategory, location.pathname, qualificationsData]);

  // Real-time search with debouncing
  useEffect(() => {
    // Skip on initial mount
    if (isInitialMount.current) return;
    
    // Don't search if keyword is empty and no search history
    if (searchQuery.keyword === '' && !searchHistory) return;
    
    setIsTyping(true);
    const debounceTimer = setTimeout(() => {
      performSearch(searchQuery.keyword, locationData.Cities);
      setIsTyping(false);
    }, 500); // 500ms debounce

    return () => {
      clearTimeout(debounceTimer);
      setIsTyping(false);
    };
  }, [searchQuery.keyword]);

  // Auto-reload when keyword is cleared
  useEffect(() => {
    if (searchQuery.keyword === '' && searchHistory?.keyword) {
      // User cleared the search, reload all jobs
      jobhandler();
    }
  }, [searchQuery.keyword]);

  // Handle location from search navigation
  useEffect(() => {
    if (locationStateCities?.length) {
      setLocationData({
        ...locationData,
        Cities: locationStateCities
      });
      // Trigger search with these cities
      setTimeout(() => {
        searchButtonHandler(new Event('submit'));
      }, 100);
    }
  }, [locationStateCities]);

  // Function to receive Location data from child component
  const receiveDataFromChild = (data) => {
    setLocationData(data);
  };

  // Search input handler
  const searchHandler = (e) => {
    const { name, value } = e.target;
    setSearchQuery({ ...searchQuery, [name]: value });
  };

  // Initial job fetch
  const jobhandler = async (categoryKey = selectedSourceCategory) => {
    setLoading(true);
    const selectedTypes = getSourceTypes(categoryKey);
    let data = {
      cities: locationStateCities,
      sort: sortBy === "relevance" ? "date_desc" : sortBy,
    };
    if (listingQualifications.length) {
      data.qualification = listingQualifications;
    } else if (listingPage.qualificationKey) {
      data.keyword = QUALIFICATION_FALLBACK_KEYWORD[listingPage.qualificationKey];
    }
    if (selectedTypes.length) {
      data.type = selectedTypes;
    }
    
    const removeEmpty = (obj) => {
      for (const key in obj) {
        if (
          obj[key] === null ||
          obj[key] === undefined ||
          (typeof obj[key] === "string" && obj[key].trim() === "")
        ) {
          delete obj[key];
        } else if (Array.isArray(obj[key])) {
          obj[key] = obj[key].filter(
            (item) => item !== null && item !== undefined
          );
          if (obj[key].length === 0) {
            delete obj[key];
          }
        }
      }
    };
    
    removeEmpty(data);
    let fromdata = await SearchJob(data);
    setSearchJob(fromdata);
    setSearchHistory(data);
    setLoading(false);
  };

  // Perform search function
  const performSearch = async (
    keyword = "",
    cities = [],
    categoryKey = selectedSourceCategory,
    qualificationNames = listingQualifications
  ) => {
    setLoading(true);

    const selectedTypes = getSourceTypes(categoryKey);
    const resolvedQualifications = qualificationNames?.length
      ? qualificationNames
      : searchQuery.industry
        ? [searchQuery.industry]
        : [];
    const resolvedKeyword =
      keyword ||
      searchQuery.keyword ||
      (!resolvedQualifications.length && listingPage.qualificationKey
        ? QUALIFICATION_FALLBACK_KEYWORD[listingPage.qualificationKey]
        : "");

    let data = {
      keyword: resolvedKeyword,
      days_ago: searchQuery.daysAgo,
      qualification: resolvedQualifications,
      from_exp: searchQuery.exp_from,
      to_exp: searchQuery.exp_to,
      ctc_from_lacs: searchQuery.ctc_from_lacs,
      ctc_from_thousand: searchQuery.ctc_from_thousand,
      ctc_to_lacs: searchQuery.ctc_to_lacs,
      ctc_to_thousand: searchQuery.ctc_to_thousand,
      country: locationData.Country,
      cities: cities.length > 0 ? cities : locationData.Cities,
      sort: sortBy === "relevance" ? "date_desc" : sortBy,
    };
    if (selectedTypes.length) {
      data.type = selectedTypes;
    }

    const removeEmpty = (obj) => {
      for (const key in obj) {
        if (
          obj[key] === null ||
          obj[key] === undefined ||
          (typeof obj[key] === "string" && obj[key].trim() === "")
        ) {
          delete obj[key];
        } else if (Array.isArray(obj[key])) {
          obj[key] = obj[key].filter(
            (item) => item !== null && item !== undefined
          );
          if (obj[key].length === 0) {
            delete obj[key];
          }
        }
      }
    };

    removeEmpty(data);
    let fromdata = await SearchJob(data);
    setSearchJob(fromdata);
    setSearchHistory(data);
    setLoading(false);
  };

  // Search button handler
  const searchButtonHandler = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    
    await performSearch();
    
    // Close filters on mobile after search
    if (window.innerWidth <= 992) {
      setShowFilters(false);
    }
  };

  // Clear all filters
  const clearAllFilters = () => {
    setSearchQuery({
      keyword: "",
      daysAgo: "",
      industry: listingQualifications[0] || "",
      exp_from: "",
      exp_to: "",
      ctc_from_lacs: "",
      ctc_from_thousand: "",
      ctc_to_lacs: "",
      ctc_to_thousand: "",
    });
    setLocationData({
      Country: "",
      State: "",
      Cities: [],
    });
    setSelectedSourceCategory(listingPage.source || "all");
    jobhandler(listingPage.source || "all");
  };

  const handleSourceCategoryChange = async (categoryKey) => {
    if (!listingPage.qualificationKey) {
      const nextPath = SOURCE_PATHS[categoryKey];
      if (nextPath && nextPath !== location.pathname) {
        navigate(nextPath);
        return;
      }
    }

    setSelectedSourceCategory(categoryKey);
    setLoading(true);

    const selectedTypes = getSourceTypes(categoryKey);
    const data = {
      ...searchHistory,
      page: 1,
      cities: locationData.Cities,
      country: locationData.Country,
      sort: sortBy === "relevance" ? "date_desc" : sortBy,
    };

    if (selectedTypes.length) {
      data.type = selectedTypes;
    } else {
      delete data.type;
    }

    const removeEmpty = (obj) => {
      for (const key in obj) {
        if (
          obj[key] === null ||
          obj[key] === undefined ||
          (typeof obj[key] === "string" && obj[key].trim() === "")
        ) {
          delete obj[key];
        } else if (Array.isArray(obj[key])) {
          obj[key] = obj[key].filter(
            (item) => item !== null && item !== undefined
          );
          if (obj[key].length === 0) {
            delete obj[key];
          }
        }
      }
    };

    removeEmpty(data);
    const fromdata = await SearchJob(data);
    setSearchJob(fromdata);
    setSearchHistory(data);
    setLoading(false);
  };

  const viewHandler = (id) => {
    navigate(`/job-description/${id}`);
  };

  // Save/bookmark job
  const handleSaveJob = async (e, jobId) => {
    e.stopPropagation();
    
    if (savedJobs.has(jobId)) {
      setSavedJobs(prev => {
        const newSet = new Set(prev);
        newSet.delete(jobId);
        return newSet;
      });
      toast.success("Job removed from saved jobs");
    } else {
      try {
        await CreateMyJobs(jobId);
        setSavedJobs(prev => new Set(prev).add(jobId));
        toast.success("Job saved successfully!");
      } catch (error) {
        toast.error("Failed to save job");
      }
    }
  };

  // Pagination
  const handlePageChange = async (page) => {
    setLoading(true);
    window.scrollTo({ top: 0, behavior: 'smooth' });
    let data = { ...searchHistory, page };
    let fromdata = await SearchJob(data);
    setSearchJob(fromdata);
    setLoading(false);
  };

  const handleSortChange = async (key) => {
    setSortBy(key);
    setShowSortDropdown(false);

    if (key === sortBy) return;

    setLoading(true);
    window.scrollTo({ top: 0, behavior: 'smooth' });
    const data = {
      ...(searchHistory || {}),
      page: 1,
      sort: key === "relevance" ? "date_desc" : key,
    };
    const fromdata = await SearchJob(data);
    setSearchJob(fromdata);
    setSearchHistory(data);
    setLoading(false);
  };

  // Calculate pagination range
  const getPageNumbers = () => {
    if (!searchedJob?.pagination) return [];
    
    const { page, totalPages } = searchedJob.pagination;
    const delta = 2;
    const range = [];
    const rangeWithDots = [];

    for (
      let i = Math.max(2, page - delta);
      i <= Math.min(totalPages - 1, page + delta);
      i++
    ) {
      range.push(i);
    }

    if (page - delta > 2) {
      rangeWithDots.push(1, '...');
    } else {
      rangeWithDots.push(1);
    }

    rangeWithDots.push(...range);

    if (page + delta < totalPages - 1) {
      rangeWithDots.push('...', totalPages);
    } else if (totalPages > 1) {
      rangeWithDots.push(totalPages);
    }

    return rangeWithDots;
  };

  // Get filtered and sorted jobs
  const getDisplayJobs = () => {
    let jobs = searchedJob?.docs?.filter(
      (job) => job?.admin_approval === "approved" && job?.is_active
    ) || [];

    // Sort jobs based on selected sort option
    if (sortBy === "date_desc") {
      jobs.sort((a, b) => new Date(b.admin_approval_date) - new Date(a.admin_approval_date));
    } else if (sortBy === "date_asc") {
      jobs.sort((a, b) => new Date(a.admin_approval_date) - new Date(b.admin_approval_date));
    } else if (sortBy === "salary_desc") {
      jobs.sort((a, b) => compareSalary(a, b, "desc"));
    } else if (sortBy === "salary_asc") {
      jobs.sort((a, b) => compareSalary(a, b, "asc"));
    }

    return jobs;
  };

  const displayJobs = getDisplayJobs();

  const sortLabelMap = {
    relevance: "Most Relevant",
    date_desc: "Newest First",
    date_asc: "Oldest First",
    salary_desc: "Salary: High to Low",
    salary_asc: "Salary: Low to High",
  };

  const daysAgoOptions = [
    { value: '', label: 'Any Time' },
    { value: '1', label: 'Last 24 hours' },
    { value: '3', label: 'Last 3 Days' },
    { value: '7', label: 'Last 7 Days' },
    { value: '15', label: 'Last 15 Days' },
    { value: '30', label: 'Last 30 Days' },
  ];

  const industryOptions = [
    { value: '', label: 'All Categories' },
    ...(qualificationsData?.map((q) => ({ value: q?.name, label: q?.name })) || []),
  ];

  const yearOptions = [
    { value: '', label: 'Any' },
    ...(yearOption?.map((v) => ({ value: String(v), label: `${v} Year${v !== 1 ? 's' : ''}` })) || []),
  ];

  const lacOptions = [
    { value: '', label: 'Lacs' },
    ...(lacOption?.map((v) => ({ value: String(v), label: `${v}L` })) || []),
  ];

  const thousandOptions = [
    { value: '', label: 'Thousands' },
    ...(thousandOption?.map((v) => ({ value: String(v), label: `${v}K` })) || []),
  ];

  const listingBreadcrumbs = [
    { name: "Home", path: "/" },
    { name: listingPage.h1 || "Jobs", path: location.pathname },
  ];

  return (
    <div className="featured-job-page">
      <SeoHead
        title={listingPage.title}
        description={listingPage.description}
        path={location.pathname}
        breadcrumbs={listingBreadcrumbs}
        jsonLd={displayJobs.length ? [buildItemListJsonLd(displayJobs)] : []}
      />
      <div className="featured-job-header">
        <div className="header-shell">
          <div className="hero-frame">
            <div className="header-content header-content-top">
              <nav className="seo-breadcrumb" aria-label="Breadcrumb">
                <Link to="/">Home</Link>
                <span aria-hidden="true"> / </span>
                <span>{listingPage.h1 || "Jobs"}</span>
              </nav>
              <p className="header-greeting">Welcome{firstName ? `, ${firstName}` : ""}</p>
              <h1 className="header-title">{listingPage.h1 || "Jobs for you"}</h1>
              {listingPage.intro && <p className="header-intro">{listingPage.intro}</p>}
            </div>

            <div className="hero-layout">
              <div className="hero-actions">
                <div className="source-category-strip" role="tablist" aria-label="Job source categories">
                  {LEGACY_JOB_SOURCE_CATEGORIES.map((category) => (
                    <div key={category.key} className="source-category-item">
                      {listingPage.qualificationKey ? (
                        <button
                          type="button"
                          className={`source-category-pill ${selectedSourceCategory === category.key ? "active" : ""}`}
                          onClick={() => handleSourceCategoryChange(category.key)}
                          aria-pressed={selectedSourceCategory === category.key}
                        >
                          {category.label}
                        </button>
                      ) : (
                        <Link
                          to={SOURCE_PATHS[category.key]}
                          className={`source-category-pill ${selectedSourceCategory === category.key ? "active" : ""}`}
                          aria-current={selectedSourceCategory === category.key ? "page" : undefined}
                        >
                          {category.label}
                        </Link>
                      )}
                    </div>
                  ))}
                </div>
              </div>

              <div className="search-bar-container search-bar-container-top hero-search-inline">
                <form onSubmit={searchButtonHandler} className="job-search-form">
                  <div className="search-input-wrapper">
                    <FaSearch className="search-icon" />
                    <input
                      type="text"
                      name="keyword"
                      value={searchQuery.keyword}
                      onChange={searchHandler}
                      placeholder="Search by job title, skills, or company..."
                      className="search-input"
                    />
                    {isTyping && searchQuery.keyword && (
                      <span className="typing-indicator">Searching...</span>
                    )}
                    {searchQuery.keyword && !isTyping && (
                      <button
                        type="button"
                        className="clear-search-btn"
                        onClick={() => setSearchQuery({ ...searchQuery, keyword: "" })}
                      >
                        ✕
                      </button>
                    )}
                  </div>
                </form>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div className="featured-job-main">
        <button
          className="mobile-filter-toggle"
          onClick={() => setShowFilters(!showFilters)}
        >
          <BsFilter size={20} />
          {showFilters ? 'Hide Filters' : 'Show Filters'}
        </button>

        <aside className={`filter-sidebar ${showFilters ? 'show-mobile' : ''}`}>
          <div className="filter-header">
            <h3>
              <BsFilter />
              Filters
            </h3>
            <button className="clear-filters-btn" onClick={clearAllFilters}>
              Clear All
            </button>
          </div>

          {/* Job Posted Date */}
          <div className="filter-section">
            <label className="filter-label">Job Posted</label>
            <FilterDropdown
              name="daysAgo"
              value={searchQuery.daysAgo}
              options={daysAgoOptions}
              placeholder="Any Time"
              openFilter={openFilter}
              setOpenFilter={setOpenFilter}
              onChange={searchHandler}
            />
          </div>

          {/* Job Category/Industry */}
          <div className="filter-section">
            <label className="filter-label">Job Category</label>
            <FilterDropdown
              name="industry"
              value={searchQuery.industry}
              options={industryOptions}
              placeholder="All Categories"
              openFilter={openFilter}
              setOpenFilter={setOpenFilter}
              onChange={searchHandler}
            />
          </div>

          {/* Experience */}
          <div className="filter-section">
            <label className="filter-label">Experience</label>
            <div className="experience-inputs">
              <div className="input-group">
                <label className="filter-label">From (Years)</label>
                <FilterDropdown
                  name="exp_from"
                  value={searchQuery.exp_from}
                  options={yearOptions}
                  placeholder="Any"
                  openFilter={openFilter}
                  setOpenFilter={setOpenFilter}
                  onChange={searchHandler}
                />
              </div>
              <div className="input-group">
                <label className="filter-label">To (Years)</label>
                <FilterDropdown
                  name="exp_to"
                  value={searchQuery.exp_to}
                  options={yearOptions}
                  placeholder="Any"
                  openFilter={openFilter}
                  setOpenFilter={setOpenFilter}
                  onChange={searchHandler}
                />
              </div>
            </div>
          </div>

          {/* Salary */}
          <div className="filter-section">
            <label className="filter-label">Salary (INR Per Annum)</label>
            <div className="salary-inputs">
              <div>
                <div className="salary-label">From</div>
                <div className="salary-row">
                  <FilterDropdown
                    name="ctc_from_lacs"
                    value={searchQuery.ctc_from_lacs}
                    options={lacOptions}
                    placeholder="Lacs"
                    openFilter={openFilter}
                    setOpenFilter={setOpenFilter}
                    onChange={searchHandler}
                  />
                  <FilterDropdown
                    name="ctc_from_thousand"
                    value={searchQuery.ctc_from_thousand}
                    options={thousandOptions}
                    placeholder="Thousands"
                    openFilter={openFilter}
                    setOpenFilter={setOpenFilter}
                    onChange={searchHandler}
                  />
                </div>
              </div>
              <div>
                <div className="salary-label">To</div>
                <div className="salary-row">
                  <FilterDropdown
                    name="ctc_to_lacs"
                    value={searchQuery.ctc_to_lacs}
                    options={lacOptions}
                    placeholder="Lacs"
                    openFilter={openFilter}
                    setOpenFilter={setOpenFilter}
                    onChange={searchHandler}
                  />
                  <FilterDropdown
                    name="ctc_to_thousand"
                    value={searchQuery.ctc_to_thousand}
                    options={thousandOptions}
                    placeholder="Thousands"
                    openFilter={openFilter}
                    setOpenFilter={setOpenFilter}
                    onChange={searchHandler}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Location */}
          <div className="filter-section">
            <label className="filter-label">Location</label>
            <Location sendDataToParent={receiveDataFromChild} />
          </div>

          {/* Apply Filters Button */}
          <button onClick={searchButtonHandler} className="apply-filters-btn">
            Apply Filters
          </button>
        </aside>

        {/* Jobs Content */}
        <div className="jobs-content">
          {/* Control Bar */}
          <div className="jobs-control-bar">
            <div className="results-info">
              {displayJobs.length > 0 ? (
                <>
                  Showing <span className="results-count">{displayJobs.length}</span> jobs
                  {searchedJob?.pagination?.totalDocs && (
                    <> of <span className="results-count">{searchedJob.pagination.totalDocs}</span></>
                  )}
                  <span className="results-category-label">
                    {LEGACY_JOB_SOURCE_CATEGORIES.find((item) => item.key === selectedSourceCategory)?.label}
                  </span>
                </>
              ) : (
                'No jobs found'
              )}
            </div>

            <div className="control-actions">
              {/* Sort Dropdown */}
              <div className="sort-dropdown-wrapper" ref={sortDropdownRef}>
                <button
                  className="sort-chip-btn"
                  onClick={() => setShowSortDropdown((prev) => !prev)}
                >
                  <FaSortAmountDown />
                  <span>Sort</span>
                  <span className="sort-chip-current">{sortLabelMap[sortBy]}</span>
                  <span className={`sort-chip-arrow ${showSortDropdown ? 'open' : ''}`}>▾</span>
                </button>
                {showSortDropdown && (
                  <div className="sort-dropdown-menu">
                    {Object.entries(sortLabelMap).map(([key, label]) => (
                      <button
                        key={key}
                        className={`sort-option-item ${sortBy === key ? 'active' : ''}`}
                        onClick={() => handleSortChange(key)}
                      >
                        {label}
                      </button>
                    ))}
                  </div>
                )}
              </div>

              {/* View Toggle */}
              <div className="view-toggle">
                <button
                  className={`layout-view-btn ${viewMode === 'grid' ? 'active' : ''}`}
                  onClick={() => setViewMode('grid')}
                  aria-pressed={viewMode === 'grid'}
                  title="Grid View"
                >
                  <FaThLarge />
                </button>
                <button
                  className={`layout-view-btn ${viewMode === 'list' ? 'active' : ''}`}
                  onClick={() => setViewMode('list')}
                  aria-pressed={viewMode === 'list'}
                  title="List View"
                >
                  <FaList />
                </button>
              </div>
            </div>
          </div>
          {/* Search Results Info */}
          {searchQuery.keyword && !loading && (
            <div className="search-results-info">
              <p>
                Showing results for <strong>"{searchQuery.keyword}"</strong>
                {displayJobs.length > 0 && ` - ${displayJobs.length} job${displayJobs.length !== 1 ? 's' : ''} found`}
              </p>
            </div>
          )}
          {/* Jobs List */}
          <div className="jobs-list">
            {loading ? (
              <div className="loading-container">
                <BarLoader color="#4893B3" width={200} />
              </div>
            ) : displayJobs.length === 0 ? (
              <div className="no-results">
                <img src={SearchImg} alt="No results" />
                <h5>No jobs found matching your criteria</h5>
              </div>
            ) : (
              <div className={viewMode === 'grid' ? 'jobs-grid' : 'jobs-list-view'}>
                {displayJobs.map((job, index) => (
                  <div
                    key={job._id || index}
                    className={`modern-job-card ${viewMode === 'list' ? 'list-view' : ''}`}
                    onClick={() => viewHandler(job._id)}
                  >
                    <div>
                      <div className="job-card-header">
                        <div>
                          <h3 className="job-card-title">{job?.title || "N/A"}</h3>
                          <p className="job-card-company">{job?.company_name || "N/A"}</p>
                        </div>
                        <button
                          className={`save-job-btn ${savedJobs.has(job._id) ? 'saved' : ''}`}
                          onClick={(e) => handleSaveJob(e, job._id)}
                          title={savedJobs.has(job._id) ? "Remove from saved" : "Save job"}
                        >
                          {savedJobs.has(job._id) ? <FaBookmark /> : <FaRegBookmark />}
                        </button>
                      </div>

                      <div className="job-card-details">
                        {job?.exp && job.exp.from !== null && job.exp.from !== undefined && 
                         job.exp.to !== null && job.exp.to !== undefined && (
                          <div className="job-detail-item">
                            <PiBagSimple />
                            <span>{job.exp.from} - {job.exp.to} Years</span>
                          </div>
                        )}
                        {job?.ctc && job.ctc.from_lac !== null && job.ctc.from_lac !== undefined && 
                         job.ctc.to_lac !== null && job.ctc.to_lac !== undefined && (
                          <div className="job-detail-item">
                            <LiaRupeeSignSolid />
                            <span>{job.ctc.from_lac} - {job.ctc.to_lac} LPA</span>
                          </div>
                        )}
                        {formatJobLocation(job) && (
                          <div className="job-detail-item">
                            <GoLocation />
                            <span>{formatJobLocation(job)}</span>
                          </div>
                        )}
                        {job?.industry?.name && (
                          <div className="job-detail-item">
                            <LiaIndustrySolid />
                            <span>{job.industry.name}</span>
                          </div>
                        )}
                      </div>

                      {job?.qualification?.length > 0 && (
                        <div className="job-card-qualifications">
                          {job.qualification.slice(0, 3).map((qual, idx) => (
                            <span key={idx} className="qualification-badge">
                              {qual?.name}
                            </span>
                          ))}
                          {job.qualification.length > 3 && (
                            <span className="qualification-badge">
                              +{job.qualification.length - 3} more
                            </span>
                          )}
                        </div>
                      )}

                      <div className="job-card-footer">
                        <span className="job-type-badge">
                          {job?.category || "Full Time"}
                        </span>
                        <span className="job-posted-time">
                          {formatTimeAgo(new Date(job?.admin_approval_date))}
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}

            {/* Pagination */}
            {!loading && displayJobs.length > 0 && searchedJob?.pagination && (
              <div className="pagination-container">
                <ul className="pagination">
                  <li className={`page-item ${!searchedJob.pagination.prevPage ? 'disabled' : ''}`}>
                    <button
                      className="page-link"
                      onClick={() => handlePageChange(searchedJob.pagination.prevPage)}
                      disabled={!searchedJob.pagination.prevPage}
                    >
                      Previous
                    </button>
                  </li>
                  {getPageNumbers().map((pageNum, idx) => (
                    <li
                      key={idx}
                      className={`page-item ${
                        pageNum === searchedJob.pagination.page ? 'active' : ''
                      } ${pageNum === '...' ? 'disabled' : ''}`}
                    >
                      {pageNum === '...' ? (
                        <span className="page-link">...</span>
                      ) : (
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(pageNum)}
                        >
                          {pageNum}
                        </button>
                      )}
                    </li>
                  ))}
                  <li className={`page-item ${!searchedJob.pagination.nextPage ? 'disabled' : ''}`}>
                    <button
                      className="page-link"
                      onClick={() => handlePageChange(searchedJob.pagination.nextPage)}
                      disabled={!searchedJob.pagination.nextPage}
                    >
                      Next
                    </button>
                  </li>
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeaturedJobModern;
